import { useMemo } from 'react';
import { VStack } from '@cbhq/cds-web/layout/VStack';

import { useProfileMenuV2 } from '../ProfileMenu/providers/ProfileMenuV2Provider';
import { MenuActionItem } from '../ProfileMenu/types';

import { HelpMenuActionItem } from './HelpMenuActionItem';

export function HelpMenuActions(): JSX.Element {
  const { helpMenu } = useProfileMenuV2();

  const memoizedActions = useMemo(() => {
    return helpMenu?.actions.map((apiAction: MenuActionItem) => {
      return <HelpMenuActionItem key={apiAction.key} apiAction={apiAction} />;
    });
  }, [helpMenu]);

  const paddingBottom = useMemo(() => {
    return {
      phone: 2 as const,
      tablet: 0 as const,
      desktop: 0 as const,
    };
  }, []);

  return <VStack paddingBottom={paddingBottom}>{memoizedActions}</VStack>;
}
